export class CommissionSyntheseEdition {
    static jsonMap = {
        nbEchantillons: { key: 'nbEchantillons', optional: true, default: '' },
        volumeTotal: { key: 'volumeTotal', optional: true, default: '' },
        volumeConforme: { key: 'volumeConforme', optional: true, default: '' },
        volumeNonConforme: { key: 'volumeNonConforme', optional: true, default: '' },
        nbOperateurs: { key: 'nbOperateurs', optional: true, default: '' },
        nbNonConformes: { key: 'nbNonConformes', optional: true, default: '' },
        nbConformes: { key: 'nbConformes', optional: true, default: '' }
    };

    nbEchantillons: string;
    volumeTotal: string;
    volumeConforme: string;
    volumeNonConforme: string;
    nbOperateurs: string;
    nbNonConformes: string;
    nbConformes: string;
}
